import { render, staticRenderFns } from "./AlarmList.vue?vue&type=template&id=b8f9543e&scoped=true&"
import script from "./AlarmList.vue?vue&type=script&lang=js&"
export * from "./AlarmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f9543e",
  null
  
)

export default component.exports